import { ACADEMY_VISITED_KEY } from './cookies.const'
import { getCookie, removeCookie, setCookie } from './cookies.utils'

export function getAcademyVisited(): boolean {
  return getCookie(ACADEMY_VISITED_KEY) !== null
}

export function setAcademyVisited(): void {
  setCookie(ACADEMY_VISITED_KEY, '1', {
    expires: 365,
    path: '/',
    secure: true,
    sameSite: 'lax',
  })
}

export function removeAcademyVisited(): void {
  removeCookie(ACADEMY_VISITED_KEY, {
    path: '/',
  })
}
